module.exports = __webpack_public_path__ + "img/IMG_1155.638acc4a.png";